import {useReducedMotion, useScroll, useTransform} from 'framer-motion'
import {useRef} from 'react'

const SCALE_RANGE: [number, number] = [0.96, 1.01]
const SCROLL_PROGRESS_RANGE: [number, number] = [0.2, 0.5]
const STATIC_SCALE = 1

// Scales an element as it scrolls through the span from being half onscreen to starting to exit:
// progress 0 is the moment it's half visible (its center reaches the viewport bottom), progress 1 is
// the moment it starts exiting (its top reaches the viewport top). The scale reaches its max partway
// through that span and holds there for the rest of it. scrollYProgress is clamped to [0, 1] by these
// two checkpoints, so to start the animation earlier/later, move the checkpoints themselves (the
// offset array below) rather than pushing SCROLL_PROGRESS_RANGE below 0 or above 1 — that space is
// never reached.
export const useScrollRevealScale = () => {
  const ref = useRef<HTMLDivElement>(null)
  const {scrollYProgress} = useScroll({target: ref, offset: ['center end', 'start start']})
  const shouldReduceMotion = useReducedMotion()

  const scale = useTransform(
    scrollYProgress,
    SCROLL_PROGRESS_RANGE,
    shouldReduceMotion ? [STATIC_SCALE, STATIC_SCALE] : SCALE_RANGE,
  )

  return {ref, scale}
}
